<template>
  <div class="integralUser seller-style">
    <!-- <h2 class="f18 fb normal gray_2">拼单列表/订单汇总</h2> -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item class="f18 lin-25" :to="{ path: '/mj/groupBuying' }">拼单列表</el-breadcrumb-item>
      <el-breadcrumb-item class="f18 lin-25">订单汇总</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="box30"></div>
    <div>
      <div class="flex flex1 items-center mar20-b">
        <el-input class="w210 mar20_r" placeholder="请输入订单编号" v-model.trim="searchForm.orderId"></el-input>
        <el-input class="w210 mar20_r" placeholder="请输入买家" v-model.trim="searchForm.buyerName"></el-input>
        <el-input class="w210 mar20_r" placeholder="请输入所属上级" v-model.trim="searchForm.regimentalCommanderName"></el-input>
        <!-- <el-date-picker
          class="mar20_r"
          v-model="searchDate"
          type="datetimerange"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker> -->
        <el-button type="primary" @click="searchList">查询</el-button>
        <el-button @click="restList">重置</el-button>
        <el-button @click="exportList">导出</el-button>
      </div>
      <div class="flex flex-wrap" v-if="orderCollect.orderCount">
        <div class="pad10-b mar20-r">订单数：{{ orderCollect.orderCount }}</div>
        <div class="mar20-r pad10-b" v-for="item in orderCollect.goodsCountList" :key="item.goodsName">
          {{ item.goodsName }}商品数量：{{ item.goodsTotalCount }}{{ item.unit }}
        </div>
        <div class="pad10-b">总金额：￥{{ orderCollect.totalAmount }}</div>
      </div>
      <el-table border :data="list" row-class-name="pointer">
        <el-table-column show-overflow-tooltip prop="orderId" label="订单号" min-width="12%" />
        <el-table-column show-overflow-tooltip prop="name" label="商品信息" min-width="15%">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.goodsDetailList" :key="index">{{ item.goodsName }}*{{ item.goodsQuantity }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="linkman" label="收货人" min-width="10%" />
        <el-table-column prop="receiveAddress" label="收货地址" min-width="15%" />
        <el-table-column prop="mobile" label="联系方式" min-width="10%" />
        <el-table-column prop="orderTimeStr" label="下单时间" min-width="15%" />
        <el-table-column prop="buyerName" label="买家" min-width="10%" />
        <el-table-column prop="regimentalCommanderName" label="所属上级" min-width="10%" />
        <el-table-column prop="totalPrice" label="总金额(￥)" min-width="10%" />
        <el-table-column prop="memo" label="买家留言" min-width="15%" />
        <el-table-column label="操作" width="150">
          <!-- slot-scope="scope" -->
          <template slot-scope="scope">
            <el-button @click="openGoodDetail(scope.row.orderId)">查看商品详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="flex items-center mar40-t">
        <div class="gray9 flex-auto">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
        <el-pagination
          layout="prev, pager, next, sizes, jumper"
          background
          hide-on-single-page
          :page-size.sync="pageSize"
          :page-count="totalPage"
          :current-page.sync="pageNum"
          :page-sizes="[30, 50, 100]"
          @size-change="sizeChange"
          @current-change="currentChange"
        >
        </el-pagination>
      </div> -->
    </div>
    <el-dialog title="商品详情" :visible.sync="goodVisible" :close-on-click-modal="false" width="600px">
      <div>
        <div class="pad20_b">订单号：{{ curOrderId }}</div>
        <el-table :data="goodsList" row-key="goodsId" style="width: 100%" max-height="400" border>
          <el-table-column prop="goodsName" label="商品名称"> </el-table-column>
          <el-table-column prop="goodsQuantity" width="100" label="数量"> </el-table-column>
          <el-table-column prop="sellFactPrice" width="100" label="单价(￥)"> </el-table-column>
          <el-table-column prop="totalAmount" width="100" label="总额(￥)"> </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      env: process.env,
      combinationOrderId: "",
      searchDate: [],
      searchForm: {
        orderId: "",
        buyerName: "",
        regimentalCommanderName: "",
      },

      list: [],
      orderCollect: {},

      goodVisible: false,
      curOrderId: "",
      goodsList: [],

      pageSize: 10,
      pageNum: 1,
      totalPage: 1,
      pageTotal: 1,
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    const { id } = this.$route.query;
    this.combinationOrderId = id;
    this.getList();
  },
  methods: {
    getList() {
      const { searchDate, searchForm, combinationOrderId } = this;
      const orderTimeStart = searchDate.length ? searchDate[0] : "";
      const orderTimeEnd = searchDate.length ? searchDate[1] : "";
      this.$store
        .dispatch("groupBuying/getCombinationOrderCollect", {
          ...searchForm,
          combinationOrderId,
          orderTimeStart,
          orderTimeEnd,
        })
        .then((data) => {
          if (!data) {
            this.orderCollect = {};
            this.list = [];
            return;
          }
          const { orderList, orderCount, goodsCountList, totalAmount } = data;
          const goodList = goodsCountList.map((item) => {
            const { spec } = item;
            return {
              ...item,
              unit: spec.split("/")[1],
            };
          });
          this.list = orderList || [];
          this.orderCollect = {
            orderCount,
            goodsCountList: goodList,
            totalAmount,
          };
        });
    },
    // 导出
    exportList() {
      const { env, list, searchDate, searchForm, combinationOrderId } = this;
      if (!list.length) {
        this.$message.warning("暂无导出数据！");
        return;
      }

      const orderTimeStart = searchDate.length ? searchDate[0] : "";
      const orderTimeEnd = searchDate.length ? searchDate[1] : "";
      let url = `${env.VUE_APP_APP}rest/combinationOrderRelation/exportExcel?combinationOrderId=${combinationOrderId}`;
      url = searchForm.orderId ? `${url}&orderId=${searchForm.orderId}` : url;
      url = searchForm.buyerName ? `${url}&buyerName=${searchForm.buyerName}` : url;
      url = searchForm.regimentalCommanderName ? `${url}&regimentalCommanderName=${searchForm.regimentalCommanderName}` : url;
      url = orderTimeStart ? `${url}&orderTimeStart=${orderTimeStart}&orderTimeEnd=${orderTimeEnd}` : url;
      console.log("导出地址", url);
      window.open(url);
    },

    // 搜索
    searchList() {
      this.getList();
    },
    restList() {
      this.searchForm = {
        orderId: "",
        buyerName: "",
        regimentalCommanderName: "",
      };
      this.searchDate = [];
    },
    openGoodDetail(id) {
      this.curOrderId = id;
      this.$store
        .dispatch("groupBuying/getOrderGoodsDetailList", {
          orderId: id,
        })
        .then((data) => {
          this.goodsList = data || [];
          this.goodVisible = true;
        });
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
  },
  // 监听器
  filters: {},
};
</script>

<style lang="scss" scoped>
@import "list.scss";
</style>
